import React from 'react';

import {
  TextCustom,
  TextAppearance,
  TextSize,
  TextWeight,
  TextLineHeight,
} from '@vw-marketing/us-components';
import { TextTag, Breakpoints } from '@volkswagen-onehub/components-core';

import {
  RelatedContentTitleContainer,
  RelatedContentCardsWrapper,
  RelatedContentWrapper,
} from './styled';
import { RelatedContentCards } from './RelatedContentCards';
import { useMaintenanceContext } from '../../hooks/use-maintenance-context';

export const LiteratureRelatedContent = ({
  setLiteratureData,
  apiConfig
}: {
  setLiteratureData: (value: any) => void;
  apiConfig: string
}) => {
  const { translationHandler } = useMaintenanceContext();

  return (
    <RelatedContentWrapper>
      <RelatedContentTitleContainer>
        <TextCustom
          appearance={TextAppearance.headline300}
          tag={TextTag.p}
          style={{
            [Breakpoints.default]: {
              fontSize: TextSize.TextSize24,
              fontWeight: TextWeight.regular,
              lineHeight: TextLineHeight.TextLineHeight28,
            },
            [Breakpoints.b1600]: {
              fontSize: TextSize.TextSize32,
              fontWeight: TextWeight.regular,
              lineHeight: TextLineHeight.TextLineHeight36,
            },
          }}
        >
          {translationHandler(
            'literature.downloadables.relatedContent.title',
          ).split(' ')[0] || ''}
        </TextCustom>
        <TextCustom
          appearance={TextAppearance.label100}
          tag={TextTag.p}
          style={{
            [Breakpoints.default]: {
              fontSize: TextSize.TextSize24,
              fontWeight: TextWeight.bold,
              lineHeight: TextLineHeight.TextLineHeight28,
            },
            [Breakpoints.b1600]: {
              fontSize: TextSize.TextSize32,
              fontWeight: TextWeight.bold,
              lineHeight: TextLineHeight.TextLineHeight36,
            },
          }}
        >
          {translationHandler(
            'literature.downloadables.relatedContent.title',
          ).split(' ')[1] || ''}
        </TextCustom>
      </RelatedContentTitleContainer>
      <RelatedContentCardsWrapper>
        <RelatedContentCards
          setLiteratureData={setLiteratureData}
          apiConfig={apiConfig}
        />
      </RelatedContentCardsWrapper>
    </RelatedContentWrapper>
  );
};
